import React from 'react'
import { Useglobelcontext } from './component/blogcontext/Blogcontext';
import { NavLink } from 'react-router-dom';
import { BASE_URL } from './Config/Config';
import Auratech_Ads from './component/Auratech_Ads';

function Filterblog() {
    const { filters : { text , categoryname},filterblogdata , updatefiltervalue , updatetag , Blogdata} = Useglobelcontext();
        

    const getuniquedata = (data, property)=>{
        let newval = data.map((curelm)=>curelm[property]);
               return [...new Set(newval)];
        }
        const blogcategoryonlydata = getuniquedata(filterblogdata , "blogcategory")
       
      const  blogtagonlydata = getuniquedata(filterblogdata , "tag");
         console.log(blogtagonlydata);

  return (
    <>
    <div className="col-xxl-4 col-lg-5">
        <aside className="sidebar-area">
          <div className="widget widget_search  ">
            <form className="search-form" onSubmit={(e)=>e.preventDefault()}>
              <input 
              type="text" 
              placeholder="Search Blog..." 
              name="text"
              value={text}
              onChange={updatefiltervalue}
              />
              <button type="submit"><i className="far fa-search" /></button>
            </form>
          </div>
          <div className="widget widget_categories  ">
            <h3 className="widget_title">Categories</h3>

              <ul>
                <ul className="sub-cat" >
           {
            blogcategoryonlydata.map((curelm , index )=>
                  <li key={index}>
                    <input 
                    id={`category-${index}`}
                    name="categoryname"
                    value={curelm}
                    type="checkbox" 
                    checked={categoryname.includes(curelm)} 
                    onChange={updatefiltervalue}
                    className="form-checkbox text-blue-600 w-5 h-5 border-gray-300 rounded focus:ring-0"
                    />

                  <label htmlFor={`category-${index}`}>{curelm}<span className="checkmark "  /></label>
                   </li>
                )}
                </ul>
            </ul>

            

          </div>


          <div className="widget  ">
            <h3 className="widget_title">Recent Posts</h3>
            <div className="recent-post-wrap">

              {Blogdata.map((curdata , index)=>(
              <div className="recent-post" key={index}>
                <div className="media-img">
                  <NavLink to={`/blogdetail/${curdata.slug}`}><img src={`${BASE_URL}${curdata.image}`} alt="Blog Image" /></NavLink>
                </div>
                <div className="media-body">
                  <h4 className="post-title"><NavLink className="text-inherit" to={`/blogdetail/${curdata.slug}`}>{curdata.title}</NavLink></h4>
                  <div className="recent-post-meta">
                    {/* <NavLink to="/blog"><i className="fal fa-calendar" /> {curdata.create_date}</NavLink> */}
                    <NavLink to="/blog">
  {new Date(curdata.create_date).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  })}
</NavLink>

                  </div>
                </div>
              </div>
               ))}
            </div>
          </div>



          <div className="widget widget_tag_cloud  ">
            <h3 className="widget_title">Popular Tags</h3>
            <div className="tagcloud">
              {
                blogtagonlydata.map((curdata , index)=>
                    <a
                    key={index}
                    type='button'
                    onClick={()=>updatetag(curdata)}
                    name="Tag"
                    value={curdata}
                    >{curdata}</a>
                )
              }

            </div>
          </div>



         <Auratech_Ads/>
        </aside>
      </div>
    
    
    </>
  )
}

export default Filterblog
